import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/upkeepplan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/upkeepplan/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/upkeepplan/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/upkeepplan/savePlan', params,options)

export const update = (params, options) =>
request.post('/api/upkeepplan/update', params,options)


// 字典接口
export const getDictionary = (params) => {
    return request({
      url: '/api/blade-system/dict/dictionary?code='+params,
      method: 'get',
    })
  }
  // 获取合同
  export const getContractList= (params, options) =>
  request.get('/api/v4ward/contract/queryList', Object.assign({}, options, { params }))
// 获取设备
  export const getContractId = (params, options) =>
  request.get('/api/device/queryList', Object.assign({}, options, { params }))
  
//   获取配件
  export const getDevicePartId = (params, options) =>
  request.get('/api/devicepart/queryList', Object.assign({}, options, { params }))
// 获取合同详细信息
export const getContractDetail = (params, options) =>
  request.get('/api/v4ward/contract/detail', Object.assign({}, options, {params}))

